import http from "@/tools/http";

export default {
  getAllTree(orgUUID) {
    return http.get(`/organizations/${orgUUID}/teams?format=tree`);
  },
  getAll(orgUUID, pagination) {
    return http.get(`/organizations/${orgUUID}/teams`, { params: pagination });
  },
  getOne(orgUUID, teamUUID) {
    return http.get(`/organizations/${orgUUID}/teams/${teamUUID}`);
  },
  delete(orgUUID, teamUUID, newTeamUUID) {
    if (newTeamUUID) {
      return http.delete(`/organizations/${orgUUID}/teams/${teamUUID}?newTeamUUID=${newTeamUUID}`);
    }
    return http.delete(`/organizations/${orgUUID}/teams/${teamUUID}`);
  },
  create(orgUUID, data) {
    return http.post(`/organizations/${orgUUID}/teams`, data);
  },
  update(orgUUID, data) {
    return http.patch(`/organizations/${orgUUID}/teams/${data.uuid}`, data);
  },
  addUser(orgUUID, teamUUID, userUUID) {
    return http.post(`/organizations/${orgUUID}/teams/${teamUUID}/users`, { user_uuid: userUUID });
  },
  removeUser(orgUUID, teamUUID, userUUID) {
    return http.delete(`/organizations/${orgUUID}/teams/${teamUUID}/users/${userUUID}`);
  },
  getAccess(orgUUID, parentUUID) {
    if (parentUUID) {
      return http.get(`/organizations/${orgUUID}/teams/accesses/${parentUUID}`);
    }
    return http.get(`/organizations/${orgUUID}/teams/accesses`);
  },
  reparent(orgUUID, teamUUID, parentUUID) {
    if (parentUUID) {
      return http.patch(`/organizations/${orgUUID}/teams/${teamUUID}/reparent/${parentUUID}`);
    }
    return http.patch(`/organizations/${orgUUID}/teams/${teamUUID}/reparent/`);
  }
};
